import React, {Component} from "react"
import PropTypes from "prop-types"

export default class NRTTextInput extends Component {

    state = {
        value: this.props.value || ''
    }

    focus() {
        this.input.focus()
    }


    handleChange = (evt) => {
        const value = evt.target.value
        this.setState({value},()=>this.props.onChange(value))

    }

    checkIfIsEnterKey = (evt) => {

        if (evt.key === 'Enter' && this.props.onEnterPressed )
            return this.props.onEnterPressed()
    }



    render() {



        return (
            <input
                onKeyDown={this.checkIfIsEnterKey}
                ref={input => this.input = input}
                type={"text"}
                {...this.props}
                value={this.state.value}
                onChange={this.handleChange}

            />
        )
    }
}

NRTTextInput.propTypes = {
    type: PropTypes.string,
    onEnterPressed: PropTypes.func,
}

NRTTextInput.defaultProps = {
    type: 'text',
    onEnterPressed: ()=>null ,
}



// WEBPACK FOOTER //
// ./src/components/_common/_form/TextInput/index.js